export default __webpack_public_path__ + "static/media/featured_area_mississauga.586e98b7.webp";